// ----------------------For PRODUCTION START------------------------

export const APP_VERSION = '1.4.2';

// ----------------------For PRODUCTION END------------------------


// ----------------------For UAT START------------------------

// export const APP_VERSION = '3.9';

// ----------------------For UAT END------------------------